export class Views {
  static CourseContent(): Promise<any> {
    return import("./CourseStudent/CourseContent/course-content.vue");
  }

  static TraditionalContent(): Promise<any> {
    return import("./CourseStudent/TraditionalContent/index.vue");
  }

  static About(): Promise<any> {
    return import("./About/about.vue");
  }

  static CourseStudent(): Promise<any> {
    return import("./CourseStudent/CourseHome/course-home.vue");
  }

  static CourseInformation(): Promise<any> {
    return import("./CourseStudent/CourseInformation/course-information.vue");
  }

  static DashboardAdm(): Promise<any> {
    return import("./DashboardAdm/dashboard-adm.vue");
  }

  static DashboardStd(): Promise<any> {
    return import("./DashboardStd/dashboard-std.vue");
  }

  static DashboardTeacher(): Promise<any> {
    return import("./DashboardTeacher/dashboard-teacher.vue");
  }

  static EditUser(): Promise<any> {
    return import("./EditUser/edit-user.vue");
  }

  static FAQ(): Promise<any> {
    return import("./FAQ/faq.vue");
  }

  static ForgotPassword(): Promise<any> {
    return import("./ForgotPassword/forgot-password.vue");
  }

  static NewPassword(): Promise<any> {
    return import("./ForgotPassword/new-password.vue");
  }

  static Landing(): Promise<any> {
    return import("./LandingView/landing-view.vue");
  }

  static Login(): Promise<any> {
    return import("./Login/login.vue");
  }

  static NotFound(): Promise<any> {
    return import("./NotFound/not-found.vue");
  }

  static QuizStudent(): Promise<any> {
    return import("./Quiz/Student/quiz-student.vue");
  }

  static SignUpComplete(): Promise<any> {
    return import("./SignUp/sign-up-complete.vue");
  }

  static SignUp(): Promise<any> {
    return import("./SignUp/sign-up.vue");
  }

  static Users(): Promise<any> {
    return import("./Users/users.vue");
  }

  static FormUsers(): Promise<any> {
    return import("./Users/form-users.vue");
  }

  static CourseQuizResults(): Promise<any> {
    return import("./CourseStudent/CourseQuizResults/course-quiz-results.vue");
  }

  static FormCourse(): Promise<any> {
    return import("./Course/form-course.vue");
  }

  static Stats(): Promise<any> {
    return import("./Stats/stats.vue");
  }

  static Chapters(): Promise<any> {
    return import("./Chapters/chapters.vue");
  }

  static FormObjectives(): Promise<any> {
    return import("./Objectives/form-objective.vue");
  }

  static FormChapterTraditional(): Promise<any> {
    return import("./ObjectivesTraditional/form-objective.vue");
  }
  static FormsObjectiveTraditional(): Promise<any> {
    return import(
      "./ObjectivesTraditional/Objective/NewObjective/new-objective.vue"
    );
  }
  static FormQuestionTraditional(): Promise<any> {
    return import("./ObjectivesTraditional/Quiz/Questions/form-question.vue");
  }

  static FormObjects(): Promise<any> {
    return import("./Objectives/Materials/form-material.vue");
  }

  static AddMaterialLesson(): Promise<any> {
    return import(
      "./Objectives/LessonPlan/addMaterialLesson/add-material-lesson.vue"
    );
  }

  static FormQuestion(): Promise<any> {
    return import("./Objectives/Quiz/Questions/form-question.vue");
  }

  static CourseHowWorks(): Promise<any> {
    return import("./CourseStudent/CourseHowWorks/course-how-works.vue");
  }

  static GeneralSettings(): Promise<any> {
    return import("./GeneralSettings/general-settings.vue");
  }

  static CourseStats(): Promise<any> {
    return import("./Stats/Course/course.vue");
  }

  static StudentStats(): Promise<any> {
    return import("./Stats/Student/student.vue");
  }

  static ObjectiveStats(): Promise<any> {
    return import("./Stats/Objective/objective.vue");
  }

  static Crawler(): Promise<any> {
    return import("./Crawler/crawler.vue");
  }
  static Organizations(): Promise<any> {
    return import("./Organizations/organizations.vue");
  }

  static FormsOrganizations(): Promise<any> {
    return import("./Organizations/Form/form-organizations.vue");
  }

  static Blacklist(): Promise<any> {
    return import("./Blacklist/blacklist.vue");
  }

  static Classes(): Promise<any> {
    return import("./Classes/classes-management.vue");
  }

  static FormClasses(): Promise<any> {
    return import("./Classes/Content/Form/form-classes.vue");
  }

  static FormActivity(): Promise<any> {
    return import("./Classes/Activities/Form/form-activities.vue");
  }

  static Forum(): Promise<any> {
    return import("./CourseStudent/Forum/ListTopics/forum.vue");
  }

  static FormTopic(): Promise<any> {
    return import("./CourseStudent/Forum/FormTopic/form-topic.vue");
  }

  static TopicDetail(): Promise<any> {
    return import("./CourseStudent/Forum/TopicDetail/topic-detail.vue");
  }

  static EditComment(): Promise<any> {
    return import(
      "./CourseStudent/Forum/TopicDetail/EditComment/edit-comment.vue"
    );
  }

  static ListForums(): Promise<any> {
    return import("./CourseStudent/Forum/index.vue");
  }

  static Calendar(): Promise<any> {
    return import("./Calendar/calendar.vue");
  }

  static Themes(): Promise<any> {
    return import("./Themes/index.vue");
  }

  static H5PContent(): Promise<any> {
    return import("./CourseStudent/InteractiveContent/index.vue");
  }

  static ActivityDetail(): Promise<any> {
    return import("./Classes/Activities/Details/details-activities.vue");
  }

  static StudentActivities(): Promise<any> {
    return import("./CourseStudent/Activities/activities-list.vue");
  }

  static StudentActivityDetail(): Promise<any> {
    return import("./CourseStudent/Activities/activity-detail.vue");
  }
}
